import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-0 rounded-3 position-relative z-1 p-25 bg-card-text-c my-featured-listings-bg" }
const _hoisted_2 = { class: "position-absolute top-0 start-0 m-2" }
const _hoisted_3 = {
  class: "d-inline-block bg-card-text-c px-2 rounded-1 text-danger-50 fs-12 fw-medium",
  style: {"padding-top":"3px","padding-bottom":"3px"}
}
const _hoisted_4 = {
  class: "bg-white rounded-bottom-2",
  style: {"padding":"20px"}
}
const _hoisted_5 = { class: "fs-16 fw-semibold mb-6" }
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = { class: "px-0 pb-13 mb-13 border-bottom mt-13 list-unstyled d-flex justify-content-between align-items-center" }
const _hoisted_8 = { class: "d-flex align-items-center gap-1 text-body" }
const _hoisted_9 = { class: "d-flex align-items-center gap-1 text-body" }
const _hoisted_10 = { class: "d-flex align-items-center gap-1 text-body" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_12 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-1 mb-4" }, [
      _createElementVNode("h5", { class: "mb-0" }, "My Featured Listings"),
      _createElementVNode("div", { class: "" }, [
        _createElementVNode("div", { class: "swiper-pagination-my-featured-listings" })
      ])
    ], -1)),
    _createVNode(_component_Swiper, {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: false,
      preventClicks: true,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.swiper-pagination-my-featured-listings',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        576: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 2,
        },
        1440: {
          slidesPerView: 2,
        },
        1850: {
          slidesPerView: 2,
        },
      },
      modules: _ctx.modules,
      class: "my-featured-listings-slide"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featuredProperties, (property, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
            default: _withCtx(() => [
              _createVNode(_component_RouterLink, {
                to: "/real-estate-agent/property-details",
                class: "text-decoration-none position-relative d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "position-relative z-1 bg-img rounded-top-2",
                    style: _normalizeStyle({
              'background-image': `url(${property.image})`,
              height: '202px',
            })
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(property.type), 1)
                    ])
                  ], 4),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", _hoisted_5, _toDisplayString(property.title), 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(property.location), 1),
                    _createElementVNode("ul", _hoisted_7, [
                      _createElementVNode("li", _hoisted_8, [
                        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "open_run", -1)),
                        _createElementVNode("span", null, _toDisplayString(property.area) + " Sft", 1)
                      ]),
                      _createElementVNode("li", _hoisted_9, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "bed", -1)),
                        _createElementVNode("span", null, _toDisplayString(property.bedrooms) + " Bed", 1)
                      ]),
                      _createElementVNode("li", _hoisted_10, [
                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "bathtub", -1)),
                        _createElementVNode("span", null, _toDisplayString(property.bathrooms) + " Bath", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h3", _hoisted_12, "$" + _toDisplayString(property.price) + "/m", 1),
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-arrow-right-line wh-30 d-flex justify-content-center align-items-center bg-border-color rounded-circle hover-bg lh-1" }, null, -1))
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}